import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AsideToggleService {
  private minimized = new BehaviorSubject<boolean>(false);
  readonly isMinimized$ = this.minimized.asObservable();

  toggle(): void {
    this.minimized.next(!this.minimized.value);
  }

  get isMinimized(): boolean {
    return this.minimized.value;
  }
}
